import OnlineAppComponent from "../lib/online_app_component";

export const OnlineAppStatusConfig = {
  componentTypeKey: "OnlineAppStatus",
  baseHtmlClass: "online_app__status",
  selector: ".online_app__status",

  linerSelector: ".online_app__status__liner",
  messageSelector: ".online_app__status__message",
};

export class OnlineAppStatus extends OnlineAppComponent {
  static get config() {
    return OnlineAppStatusConfig;
  }

  constructor(id_or_element, onlineApp) {
    super(id_or_element, onlineApp, OnlineAppStatus.config);
    this.messageElement = this.element.querySelector(OnlineAppStatus.config.messageSelector);
  }

  render() {
    const status = this.getStatus();
    this.swapHtmlClassStates(!!status, "present", "absent");
    this.messageElement.innerHTML = (!!status) ? `${status.message}` : '';
    this.conditionallySetHtmlClassState(status?.type === 'ERROR', 'error');
  }

  getStatus() {
    if (this.readStateMachineValue("initializingFailed")) return { message: `A problem occurred, please try again.`, type: 'ERROR'};

    const loadingItems = this.readStateMachineValue("loadingItems");
    if (loadingItems && loadingItems.length > 0) {
      const label = loadingItems.map((item) => item.label).join(", ");
      return { message: `Loading ${label}…` };
    }
  }
}

export function getStatus(element, onlineApp) {
  if (!element) return null;
  return new OnlineAppStatus(element, onlineApp);
}
